import React, { Component } from 'react'
import LinkIcon from '@components/Icon/Link'
import Tooltip from '@components/Tooltip'
import propTypes from 'prop-types'
import { userApi } from '@atheneum/api'
import { inject } from 'mobx-react'

class LoginAs extends Component {
  static propTypes = {
    userId: propTypes.number.isRequired,
    children: propTypes.element,
    modalStore: propTypes.object
  }

  onClick = async e => {
    e.stopPropagation()
    e.preventDefault()
    const token = await userApi.getQuickLoginToken(this.props.userId)
    this.props.modalStore.show({
      type: 'LOGIN_AS_MODAL',
      props: {
        token
      }
    })

    return false
  }

  render () {
    if (process.env.REACT_APP_LOGIN_AS_ALLOWED !== 'true') return null
    return (
      <Tooltip
        tooltip={`Click to generate quick login link you can use to login as this user`}
      >
        <div onClick={this.onClick}>
          {this.props.children || (
            // eslint-disable-next-line
            <a>
              <LinkIcon /> Login as
            </a>
          )}
        </div>
      </Tooltip>
    )
  }
}

export default inject('modalStore')(LoginAs)
